import {
  setUserSelectedOption,
  setUserSelectedOptions,
} from 'domains/store/slice'

export default function createOptionsMiddleware({ api }) {
  return () => (next) => (action) => {
    const result = next(action)
    switch (action.type) {
      case setUserSelectedOptions.toString():
        api.store.set('options', action.payload)
        break
      case setUserSelectedOption.toString():
        api.store.set('options', {
          ...(api.store.get('options') || {}),
          [action.payload.option]: action.payload.value,
        })
        break
    }
    return result
  }
}
